<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.accounting_products.form.name')"
            :is-required="true"
            :hint="__('settings.accounting_products.form.name_hint')"
        >
            <DInput
                id="name"
                v-model="form.name"
                :placeholder="__('settings.accounting_products.form.name')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('name')"
                :invalid-feedback="errors.name"
                maxlength="45"
            />
        </DFormRow>
        <DFormRow
            v-if="isFinanceSystemNetsuite === false"
            :label="__('settings.accounting_products.form.external_cost_object_id')"
            :is-required="true"
            :hint="__('settings.accounting_products.form.external_cost_object_id_hint')"
        >
            <DInput
                id="external_cost_object_id"
                v-model="form.external_cost_object_id"
                :placeholder="__('settings.accounting_products.form.external_cost_object_id')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('external_cost_object_id')"
                :invalid-feedback="errors.external_cost_object_id"
                max="2147483647"
            />
        </DFormRow>
        <DFormRow
            v-if="isFinanceSystemNetsuite === false"
            :label="__('settings.accounting_products.form.external_cost_center_id')"
            :hint="__('settings.accounting_products.form.external_cost_center_id_hint')"
        >
            <DInput
                id="external_cost_center_id"
                v-model="form.external_cost_center_id"
                :placeholder="__('settings.accounting_products.form.external_cost_center_id')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('external_cost_center_id')"
                :invalid-feedback="errors.external_cost_center_id"
                max="2147483647"
            />
        </DFormRow>
        <DFormRow
            v-if="isFinanceSystemNetsuite === true"
            :label="__('settings.accounting_products.form.netsuite_item_id')"
            :is-required="true"
            :hint="__('settings.accounting_products.form.netsuite_item_id_hint')"
        >
            <DInput
                id="netsuite_item_id"
                v-model="form.netsuite_item_id"
                :placeholder="__('settings.accounting_products.form.netsuite_item_id')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('netsuite_item_id')"
                :invalid-feedback="errors.netsuite_item_id"
                max="2147483647"
            />
        </DFormRow>
        <DFormRow
            v-if="isFinanceSystemNetsuite === true"
            :label="__('settings.accounting_products.form.netsuite_department_id')"
            :is-required="true"
            :hint="__('settings.accounting_products.form.netsuite_department_id_hint')"
        >
            <DInput
                id="netsuite_department_id"
                v-model="form.netsuite_department_id"
                :placeholder="__('settings.accounting_products.form.netsuite_department_id')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('netsuite_department_id')"
                :invalid-feedback="errors.netsuite_department_id"
                max="2147483647"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.accounting_products.form.is_intercompany')"
            :is-required="true"
            :hint="__('settings.accounting_products.form.is_intercompany_hint')"
        >
            <DSwitch
                id="is_intercompany"
                v-model="form.is_intercompany"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="$route('settings.accounting-products.index')"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'AccountingProductForm',
    props: {
        submitUrl: {
            type: String,
            default: ''
        },
        accountingProduct: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                name: this.accountingProduct?.name ?? null,
                external_cost_object_id: this.accountingProduct?.external_cost_object_id ?? null,
                external_cost_center_id: this.accountingProduct?.external_cost_center_id ?? null,
                netsuite_item_id: this.accountingProduct?.netsuite_item_id ?? null,
                netsuite_department_id: this.accountingProduct?.netsuite_department_id ?? null,
                is_intercompany: this.accountingProduct?.is_intercompany ?? false,
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>
